import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'
import theme from '../theme'
export function FormLabel(
  { className, component: Component, cropText, htmlFor, ...props },
  { formFieldId, formLayout, labelWidth }
) {
  const finalHtmlFor = htmlFor || formFieldId

  return (
    <StyledLabel
      as={Component}
      formLayout={formLayout}
      cropText={cropText}
      labelWidth={labelWidth}
      htmlFor={finalHtmlFor}
      className={className}
      {...props}
    />
  )
}

FormLabel.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  cropText: PropTypes.bool
}
FormLabel.defaultProps = {
  component: 'label'
}
FormLabel.contextTypes = {
  formLayout: PropTypes.oneOf(['basic', 'horizontal', 'inline']),
  formFieldId: PropTypes.string,
  labelWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

const StyledLabel = styled.label`
  color: ${theme.form.label.color};
  font-size: ${theme.form.label.fontSize};
  font-weight: ${theme.form.label.fontWeight};
  display: inline-block;
  margin-bottom: 0.5em;

  ${(props) =>
    props.formLayout === 'horizontal' &&
    `
    @media (min-width: ${theme.breakpoint.tabletLandscapeMin}) {
      display: table-cell;
      line-height: ${theme.component.lineHeight};
      margin-bottom: 0;
      padding-right: 5px;
      vertical-align: top;
      width: ${theme.form.label.width};
    }
  `}

  ${(props) =>
    props.cropText &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}

  ${(props) => props.labelWidth && `width: ${props.labelWidth};`}
`

export default FormLabel
